module.exports = {
    isCarrierWithSmallBagInCabin: function(carrierCode) {
        return Odigeo._.includes(Odigeo.JCMS.carriersWithSmallBagInCabin.split(',').map((item) => item.trim()), carrierCode);
    },
};
